import { createTheme } from "@mui/material";

import { defaultTheme } from "./defaultThemeOptions";

const theme = createTheme(defaultTheme as any);

export default theme;
